<div class="flex-1 d-flex fd-col ai-stretch">
  <span class="header">
    {{ option.filterMethodConfig?.title || 'Between Dates' }}
  </span>

  <div class="d-flex fd-row gap-8" style="flex: 0 1">
    <mat-form-field class="form-field" appearance="outline">
      <mat-label>Date Range</mat-label>
      <mat-date-range-input [formGroup]="formGroup" [rangePicker]="rangePicker" #dateRangeInput>
        <input matStartDate formControlName="start" placeholder="From" #startDateInput />
        <input matEndDate formControlName="end" placeholder="To" #endDateInput />
      </mat-date-range-input>
      <suvo-bi-clear-control-button
        matSuffix
        [clearFormGroup]="formGroup"
      ></suvo-bi-clear-control-button>
      <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
      <mat-date-range-picker #rangePicker>
        <mat-date-range-picker-actions>
          <button mat-button matDateRangePickerCancel>Cancel</button>
          <button mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
        </mat-date-range-picker-actions>
      </mat-date-range-picker>
    </mat-form-field>
  </div>
</div>
